import React, {useState} from 'react';
import {Button, Col, Image} from 'react-bootstrap';
import {ProjectStyle, TextStyle} from '../assets/css/Styles';
import '../assets/css/Animations.css';

/**
 *
 * @param {Object} props - props for each project component
 * @return {Component} each project component
 */
export default function EachProject({...props}) {
  const [showDetails, setShowDetails] = useState(false);
  const [readmeButtonHover, setReadmeButtonHover] = useState(false);

  /**
   * display project details
   */
  const displayProjectDetails = () => {
    props.setName();
    props.setMotto();
    props.setDescription();
    props.setImages();
    props.setButtonInfo();
    setShowDetails(true);
  };

  /**
   * close project details
   */
  const closeProjectDetails = () => {
    setShowDetails(false);
  };
  return (
    <Col
      style={ProjectStyle.eachProjectContainer}
      onMouseEnter={() => displayProjectDetails()}
      onMouseLeave={() => closeProjectDetails()}>
      {
              showDetails ?
              (<Col
                style={ProjectStyle.eachProjectDetailsContainer}>
                <Col
                  id='each-project-title'
                  style={ProjectStyle.eachProjectTitle}>
                  <span style={TextStyle.normalTxt1}>{props.name}</span>
                </Col>
                <Col style={ProjectStyle.eachProjectToolsContainer}>
                  {
                    props.tools.map((eachTool) => (
                      <Col
                        style={ProjectStyle.eachProjectTool}
                        key={eachTool.name}
                        id='each-project-tool'>
                        <Image
                          style={ProjectStyle.eachToolIcon}
                          src={eachTool.icon}
                        />
                        <Col style={ProjectStyle.eachToolName}>
                          <span
                            style={TextStyle.normalTxt2}>
                            {eachTool.name}
                          </span>
                        </Col>
                      </Col>
                    ))
                  }
                </Col>
                <Col style={ProjectStyle.ReadmoreButtonDiv}>
                  <Button
                    id='readmore-button'
                    style={
                      readmeButtonHover ?
                      ProjectStyle.readmoreButtonActive :
                      ProjectStyle.readmoreButton}
                    onMouseEnter={() => setReadmeButtonHover(true)}
                    onMouseLeave={() => setReadmeButtonHover(false)}
                    onClick={() => props.openProjectModal()}>
                    <span style={TextStyle.normalTxt2}>Read more</span>
                  </Button>
                </Col>
              </Col>) :
              (<Image
                src={`${props.imgSrc}`}
                alt={`${props.imgSrc}`}
                style={ProjectStyle.projectImageStyle}
              />)
      }
    </Col>
  );
}
